<template>
  <div class="col-auto edit-menu flex-center">
    <b-dropdown
      variant="link"
      toggle-class="edit-menu-button text-dark text-decoration-none overflow-button"
      menu-class="overflow-menu"
      class="overflow-menu-wrapper"
      :data-idea-list-id="ideaList.id"
      :lazy="true"
      no-caret
    >
      <template slot="button-content">
        <i class="overflow-menu-icon"></i>
      </template>

      <b-dropdown-item @click.stop="$emit('open', $event)" v-if="!hideOpenOption">
        <action-key action="Open Idea List" :key-combination="['Shift', '<right>']" />
      </b-dropdown-item>
      <b-dropdown-item @click.stop="$emit('edit')">
        Edit List Name
      </b-dropdown-item>
      <b-dropdown-item @click="triggerConfirmation('delete')">Delete Idea List</b-dropdown-item>
    </b-dropdown>

    <confirm-dialog
      ref="confirmModal"
      :title="confirmationMessage.title"
      @ok="onConfirmation"
      :ok-title="confirmationMessage.ok"
      :ok-variant="action === 'delete' ? 'danger' : 'primary'"
      :cancel-title="confirmationMessage.cancel || 'No, I changed my mind'"
    >
      {{ confirmationMessage.body }}
    </confirm-dialog>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import * as R from 'ramda'
import ActionKey from '@/components/ActionKey'
import ConfirmDialog from '@/components/ConfirmDialog'
import { DEFAULT_ERROR } from '@/constants/messages'
import { TOAST_TYPE } from '@/constants/toasts'
import EventBus from '@/EventBus'
import { mapActions } from 'vuex'

const messages = {
  delete: {
    title: 'Delete this Idea List?',
    body: 'Deleting this Idea List will delete all related ideas. This action cannot be undone.',
    ok: 'Yes, delete'
  }
}

/**
 * This component is for options dropdown for Idea List Row
 * props:
 *  - ideaList
 *  - hideOpenOption: for hiding open icon (click of which open IdeaList page)
 *
 * @emits
 *  - open
 *  - deleted
 */
export default {
  name: 'IdeaListOptions',
  props: ['ideaList', 'hideOpenOption'],
  components: {
    BDropdown,
    BDropdownItem,
    ActionKey,
    ConfirmDialog
  },
  data() {
    return {
      messages,
      confirmationMessage: {},
      action: null
    }
  },
  computed: {},
  methods: {
    ...mapActions(['idea/deleteIdeaList']),
    async performDeleteIdeaList() {
      try {
        await this.deleteIdeaList({ orgId: this.ideaList.organizationId, id: this.ideaList.id })
        EventBus.$emit('ADD_TOAST', { message: 'Idea List has been deleted successfully' })
        this.$emit('deleted')
      } catch (e) {
        const message = R.pathOr(DEFAULT_ERROR, ['response', 'data', 'message'], e)
        EventBus.$emit('ADD_TOAST', { message, type: TOAST_TYPE.ERROR })
      }
    },
    triggerConfirmation(action) {
      this.action = action
      this.confirmationMessage = messages[action]
      this.$refs.confirmModal.$refs.dialog.show()
    },
    onConfirmation() {
      if (this.action === 'delete') {
        this.performDeleteIdeaList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/_styleConfigurations.scss';

.edit-menu {
  padding-top: 5px;
}

@include media-breakpoint-down(md) {
  .edit-menu {
    display: none;
  }
}
</style>
